import React, { useState, useEffect } from "react";
import { fetchApi } from "../utlis/axios";
import Lottie from "lottie-react";
import Loader from "../animation/Loader.json";
import { Link } from "react-router-dom";
import Navbar from "../Common/Navbar";
import { Footer } from "../Footer/Footer";
import Banner from "../Common/Banner";
import Card from "./MainCard";
import { Helmet } from "react-helmet";

export const Programs = () => {
  const [program, setProgram] = useState();
  const [programLoading, setProgramLoading] = useState(false);

  const fetchPrograms = async () => {
    setProgramLoading(true);
    try {
      const result = await fetchApi.get("programs/");
      if (result?.status === 200) {
        setProgram(result.data);
        setProgramLoading(false);
      }
    } catch (error) {
      console.log({ error });
      setProgramLoading(false);
    }
  };

  useEffect(() => {
    fetchPrograms();
  }, []);

  return (
    <>
    <Helmet>
<title>Our Programmes | Food, Shelter, Clothing & Education by KWF</title>
<meta name="description" content="Our programmes provide meals, safe homes, clothing, education and health services to uplift disadvantaged families across Pakistan."/>
      </Helmet>
    <div className="bg-[#FCFBF7] min-h-screen flex flex-col">
      <Navbar />
     <Banner title={'Programs'} text={`meaningful, transparent, and impactful charity`}/>
      <section className="Admindashboard__task__wrapper flex-1 md:px-8 sm:px-4 px-[16px]">
        <div className="dashboardCard font-roboto min-h-full flex flex-col">
          <h1 className="text-center !text-3xl !font-semibold mt-6">Here's What we do</h1>
          <p className="!text-lg !font-normal max-w-2xl mx-auto text-center !text-gray">Our programs are designed to address the struggles faced by underprivileged communities in Pakistan.</p>
          {programLoading && (
            <div
              style={{
                position: "absolute",
                top: "70%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 40,
              }}
            >
              <Lottie
                loop={true}
                animationData={Loader}
                style={{ width: "150px" }}
              />
            </div>
          )}
          {program?.results?.length === 0 ? (
            <div className="flex-1 flex justify-center items-center">
              <div className="">
                <b>No programs have been created.</b>
              </div>
            </div>
          ) : (
            <div className="program_main w-full max-w-screen-xl mx-auto sm:gap-10 gap-6 flex justify-start items-center md:flex-row flex-col md:pb-8 pb-6 flex-1">
              {program?.results?.map((data, index) => (
                  <Card data={data} key={data?.id}/>
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer/>
    </div>
    </>
  );
};
